export const PRIVACY_SETTINGS_INTERCOM_LINK =
  'help.eversportsmanager.com/einstellungen-zur-privatsphäre-deines-eversports-profils-eversports-help-center-deutsch'
